<script>
export default {
  name: 'AnalyticsVisitorInfoReport',
  props: {
    data: Object,
    loading: Boolean
  },
  computed: {
    avgTimeOnSite() {
      const { sessionDuration, visits } = this.parseTotals();
      const avgTimeOnSite = visits > 0 ? parseFloat(sessionDuration / visits).toFixed(0) : 0;
      return this.convertSecondsToTime(avgTimeOnSite);
    },
    bounceRate() {
      const { bounces, visits } = this.parseTotals();
      return visits > 0 ? (parseFloat(bounces / visits) * 100).toFixed(0) + '%' : 0;
    },
    newVisits() {
      const { newVisits, visits } = this.parseTotals();
      return visits > 0 ? (parseFloat(newVisits / visits) * 100).toFixed(0) + '%' : 0;
    },
    pageviews() {
      const { pageviews } = this.parseTotals();
      return parseInt(pageviews).toLocaleString();
    },
    pagesPerVisit() {
      const { pageviews, visits } = this.parseTotals();
      return visits > 0 ? parseFloat(pageviews / visits).toFixed(2) : 0;
    },
    visits() {
      const { visits } = this.parseTotals();
      return parseInt(visits).toLocaleString();
    }
  },

  methods: {
    // Converts seconds to 00:00:00
    convertSecondsToTime(seconds) {
      let hr = parseInt(seconds / 3600);
      let min = parseInt((seconds / 60) % 60);
      let sec = seconds % 60;
      if (hr < 10) hr = `0${hr}`;
      if (min < 10) min = `0${min}`;
      if (sec < 10) sec = `0${sec}`;
      return `${hr}:${min}:${sec}`;
    },

    // Returns the values of data.totalsForAllResults as an object
    parseTotals() {
      const result = {};
      const metrics = [
        'bounces',
        'entrances',
        'exits',
        'newVisits',
        'pageviews',
        'timeOnPage',
        'sessionDuration',
        'visitors',
        'visits'
      ];

      metrics.map(metric => {
        if (this.data && this.data.totalsForAllResults) {
          result[metric] = this.data.totalsForAllResults[`ga:${metric}`];
        } else {
          result[metric] = 0;
        }
      });

      return result;
    }
  }
};
</script>

<template>
  <div v-loading="loading">
    <div class="visitor-info">
      <el-row :gutter="20">
        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
          <h3>{{ visits }}</h3>
          <small>{{ $t('Visits') }}</small>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
          <h3>{{ bounceRate }}</h3>
          <small>{{ $t('Bounce Rate') }}</small>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
          <h3>{{ pageviews }}</h3>
          <small>{{ $t('Pageviews') }}</small>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
          <h3>{{ avgTimeOnSite }}</h3>
          <small>{{ $t('Average Time On Site') }}</small>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
          <h3>{{ pagesPerVisit }}</h3>
          <small>{{ $t('Pages Per Visit') }}</small>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
          <h3>{{ newVisits }}</h3>
          <small>{{ $t('New Visits') }}</small>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.visitor-info {
  text-align: center;
  margin-bottom: 1rem;

  h3 {
    font-size: 1.6rem;
    margin-bottom: .25rem;
  }

  small {
    display: block;
    color: $--color-gray-40;
    margin-bottom: 1rem;
  }
}
</style>
